import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { PageAndSizeInfo } from '@platform-workspace/design-system';
import {
  BaseList,
  BaseResponse,
  ChangeLogDependentFiltersOptionsDto,
  ChangeLogDependentFiltersOptionsResponseDto,
  ChangeLogDto,
  ChangeLogMetadataKeys,
  ChangeLogMetadataTemplates,
  ChangeLogSearchFiltersDto,
} from '@shared/utils/interfaces';
import { Observable } from 'rxjs';

import {
  getChangeLogFiltersUrl,
  getChangeLogKeysUrl,
  getChangeLogRolesUrl,
  getChangeLogTemplatesUrl,
  getChangeLogUrl,
} from './change-log.constant';

@Injectable({
  providedIn: 'root',
})
export class ChangeLogApiService {
  private readonly http = inject(HttpClient);

  getChangeLog(filters: Partial<ChangeLogSearchFiltersDto>, pagination: PageAndSizeInfo): Observable<BaseResponse<BaseList<ChangeLogDto>>> {
    return this.http.post<BaseResponse<BaseList<ChangeLogDto>>>(
      getChangeLogUrl(),
      {
        ...filters,
      },
      {
        params: {
          page: pagination.page,
          size: pagination.size,
        },
      },
    );
  }

  getDependentFiltersOptions(
    selectedFilters: ChangeLogDependentFiltersOptionsDto,
  ): Observable<BaseResponse<ChangeLogDependentFiltersOptionsResponseDto>> {
    return this.http.post<BaseResponse<ChangeLogDependentFiltersOptionsResponseDto>>(getChangeLogFiltersUrl(), selectedFilters);
  }

  getRolesOptions(): Observable<BaseResponse<string[]>> {
    return this.http.get<BaseResponse<string[]>>(getChangeLogRolesUrl());
  }

  getChangeLogTemplates(): Observable<BaseResponse<ChangeLogMetadataTemplates>> {
    return this.http.get<BaseResponse<ChangeLogMetadataTemplates>>(getChangeLogTemplatesUrl());
  }

  getChangeLogKeys(): Observable<BaseResponse<ChangeLogMetadataKeys>> {
    return this.http.get<BaseResponse<ChangeLogMetadataKeys>>(getChangeLogKeysUrl());
  }
}
